/* eslint-disable no-console */
export const fixRowDependency = {
  Q3_5_2: (
    dependencySource: any,
    targetSource?: any,
    currentFixedRows?: any
  ): any[] => {
    const output: any[] = currentFixedRows ? [] : currentFixedRows;

    if (Array.isArray(dependencySource)) {
      dependencySource.forEach((item: any, index: number) => {
        const hadRecord = targetSource?.find((w: any) => w.scopeLabel === item);
        if (hadRecord) {
          hadRecord._id = `system_${index}`;
          hadRecord.rowId = `system_${index}`;
          output.push(hadRecord);
        } else {
          output.push({
            _id: `system_${index}`,
            rowId: `system_${index}`,
            scopeLabel: item
          });
        }
      });
    }

    return output;
  },
  Q7_30_DependsOn58_FixRow: (
    dependencySource: any,
    targetSource?: any,
    currentFixedRows?: any
  ): any[] => {
    const output: any[] = [];
    if (Array.isArray(dependencySource)) {
      currentFixedRows?.forEach((item: any) => {
        if (item?.label === 'Total energy consumption') {
          const hadRecord = targetSource?.find(
            (w: any) => w.scopeLabel === 'Total energy consumption'
          );
          if (hadRecord) {
            output.push(hadRecord);
          } else {
            output.push({
              _id: item?.id,
              rowId: item?.id,
              scopeLabel: 'Total energy consumption'
            });
          }
        } else {
          const hadRecordDependencyExist = dependencySource.find(
            (w: any) =>
              w.scopeLabel === item?.label &&
              w?.[`corporatePerformanceClimateChangeQ58_1_value_${w._id}`] ===
                'Yes'
          );
          if (hadRecordDependencyExist) {
            const hadRecord = targetSource.find(
              (w: any) => w.scopeLabel === item?.label
            );
            if (hadRecord) {
              output.push(hadRecord);
            } else {
              output.push({
                _id: item?.id,
                rowId: item?.id,
                scopeLabel: item?.label
              });
            }
          }
        }
      });
    }

    return output;
  },
  Q7_21_FixRow: (
    dependencySource: any,
    targetSource?: any,
    currentFixedRows?: any
  ): any[] => {
    const output: any[] = [];
    if (Array.isArray(dependencySource)) {
      currentFixedRows?.forEach((item: any) => {
        const hadRecordDependencyExist = dependencySource.find(
          (w: any) =>
            w?.corporatePerformanceClimateChangeQ42_1_value === item?.label
        );
        if (hadRecordDependencyExist) {
          const hadRecord = targetSource.find(
            (w: any) => w.scopeLabel === item?.label
          );
          if (hadRecord) {
            output.push(hadRecord);
          } else {
            output.push({
              _id: item?.id,
              rowId: item?.id,
              scopeLabel: item?.label
            });
          }
        }
      });
    }

    return output;
  }
};
